import React from "react";
import { toast } from "react-toastify";
import { Box, Button, Divider } from "@mui/material";
import { Add } from "@mui/icons-material";

import { useVehicleDetailContext } from "contexts/VehicleDetailContext";
import { useAddVehicleNotesMutation } from "store/services/vehicleApi";

import FormDrawer from "components/Shared/FormDrawer";

import VehicleNoteList from "./VehicleNoteList";
import VehicleNotesForm from "./VehicleNotesForm";

const VehicleNotesTab = () => {
  const [showNoteForm, setShowNoteForm] = React.useState(false);
  const [selectedNote, setSelectedNote] = React.useState(null);

  const { vehicleDetail } = useVehicleDetailContext();

  // RTK Query
  const [addNote, { isLoading: addingNote }] = useAddVehicleNotesMutation();

  // methods
  const handleCancelNote = () => {
    setShowNoteForm(false);
    setSelectedNote(null);
  };

  const handleAddNote = async (data) => {
    try {
      await addNote({ ...data, vehicleId: vehicleDetail?._id }).unwrap();
      toast.success("Notes successfully added!");
      handleCancelNote();
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't add notes!");
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}>
        {!showNoteForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowNoteForm(true)}
          >
            Add Note
          </Button>
        )}
      </Box>
      <Divider />
      {/* list of notes */}
      <VehicleNoteList vehicleId={vehicleDetail._id} />

      <FormDrawer
        title="Vehicle Notes"
        open={showNoteForm}
        onClose={handleCancelNote}
      >
        <VehicleNotesForm
          isBusy={addingNote}
          note={selectedNote}
          onSubmit={handleAddNote}
          onCancel={handleCancelNote}
        />
      </FormDrawer>
    </>
  );
};

export default VehicleNotesTab;
